import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ENVIRONMENT } from 'src/app/constants';
import { NovoChamadoFormProvider } from 'src/app/providers';
import { IToken } from 'src/app/interfaces/token/IToken';
import { Environment } from 'src/app/types';
import { aoMenosUmPreenchidoValidator } from 'src/app/validators';
import { IEquipamento } from 'src/app/interfaces';

@Component({
  selector: 'app-abrir-chamado',
  templateUrl: './abrir-chamado.component.html',
  styleUrls: ['./abrir-chamado.component.scss'],
  providers: [
    {
      provide: NovoChamadoFormProvider,
      useExisting: AbrirChamadoComponent
    }
  ]
})
export class AbrirChamadoComponent
  extends NovoChamadoFormProvider
  implements OnInit, OnDestroy
{
  private subscription$ = new Subscription();
  private token: IToken;
  private chamadoForm: FormGroup;
  constructor(
    @Inject(ENVIRONMENT) private environment: Environment,
    private fb: FormBuilder
  ) {
    super();
  }
  getForm(): FormGroup {
    return this.chamadoForm;
  }

  limparForm() {
    this.chamadoForm.patchValue({
      primeiroPasso: {
        equipamento: null,
        codDefeito: '',
        contrato: null,
        numserie: '',
        numpat: '',
        codContrato: '',
        obsDefeito: '',
        motivo: ''
      },
      segundoPasso: {
        contato: '',
        celular: '',
        fone: '',
        foneaux: ''
      },
      terceiroPasso: {
        cep: '',
        logradouro: '',
        num: '',
        cidade: '',
        estado: '',
        bairro: '',
        comp: ''
      }
    });
  }

  ngOnInit(): void {
    this.chamadoForm = this.fb.group({
      primeiroPasso: this.fb.group({
        equipamento: [null, [Validators.required]],
        site: [null, [Validators.required]],
        codDefeito: ['', [Validators.required]],
        contrato: [null],
        numserie: ['', [Validators.required]],
        numpat: [''],
        codContrato: ['', [Validators.required]],
        obsDefeito: ['', [Validators.maxLength(3000)]],
        motivo: [
          '',
          [
            Validators.required,
            Validators.maxLength(50),
            Validators.minLength(0)
          ]
        ]
      }),
      segundoPasso: this.fb.group(
        {
          contato: ['', [Validators.required, Validators.maxLength(30)]],
          celular: ['', [Validators.maxLength(11)]],
          fone: ['', [Validators.maxLength(10)]],
          foneaux: ['', Validators.maxLength(11)]
        },
        {
          validators: [
            aoMenosUmPreenchidoValidator('celular', 'fone', 'foneaux')
          ]
        }
      ),
      terceiroPasso: this.fb.group({
        cep: ['', [Validators.required, Validators.maxLength(9)]],
        logradouro: ['', [Validators.required, Validators.maxLength(60)]],
        num: ['', [Validators.required]],
        cidade: ['', [Validators.required, Validators.maxLength(30)]],
        estado: ['', [Validators.required, Validators.maxLength(2)]],
        bairro: ['', [Validators.required, Validators.maxLength(30)]],
        comp: ['', [Validators.maxLength(20)]]
      })
    });
    this.subscription$.add(
      this.chamadoForm
        .get('primeiroPasso.equipamento')
        ?.valueChanges.subscribe({
          next: (equipamento: IEquipamento | string) => {
            if (!equipamento || typeof equipamento === 'string') {
              return;
            }

            this.chamadoForm.patchValue({
              primeiroPasso: {
                numserie: equipamento?.numSerie,
                numpat: equipamento?.numPat,
                codContrato: equipamento?.codigoContr
              }
            });
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
